module.exports = __webpack_public_path__ + "img/symbolsToAbc.b6e6cc1a.png";